import NotFound from '../components/NotFound';

export default function StartProject() {
  return <NotFound pageName="Start Your Project" />;
}
